/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PatientImageCard/view.blocks to change it.
import Label from './Label/index'
import Preview from './Preview/index'
import React from 'react'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function PatientImageCard({
  children,
  slot_key,
  label,
  url,
  viewPath = "/DesignSystem/PatientImageCard",
  onClick
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
  return (<React.Fragment
>
<div
  data-testid="PatientImageCard.Vertical"
  data-view-path={viewPath}
 className="views-block"
>
<button
  data-testid="PatientImageCard.Horizontal"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 className={`views-block ${styles.Horizontal}`}
>
<Preview
  viewPath={`${viewPath}/Preview`}
/>
<Label
  viewPath={`${viewPath}/Label`}
/>
</button>
</div>
{children}
</React.Fragment>)
}